/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from "@/axios.js";

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({ commit }, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit('UPDATE_USER_INFO', payload)
  },
  addItemToGrData({ commit }, newItem) {
    commit('ADD_GR', newItem)
  },
  updateGRGroupData({ commit }, newItem) {
    commit('UPDATE_GRDATA_INSIDE_GROUP', newItem)
  },

  setGrData({ commit }, newItem) {
    commit('SET_GR', newItem)
  },
  addItemToGrGroup({ commit }, newItem) {
    commit('UPDATE_GR_GROUP', newItem)
  },
  resetGrGroup({ commit }, newItem) {
    commit('RESET_GR_GROUP', newItem)
  },
  setGrGroup({ commit }, newItem) {
    commit('SET_GR_GROUP', newItem)
  },
  setGsData({ commit }, newItem) {
    commit('SET_GS', newItem)
  },
  updateGSGroupData({ commit }, newItem) {
    commit('UPDATE_GSDATA_INSIDE_GROUP', newItem)
  },
  addItemToGsData({ commit }, newItem) {
    commit('UPDATE_GS', newItem)
  },
  setGsGroup({ commit }, newItem) {
    commit('SET_GS_GROUP', newItem)
  },
  resetGsGroup({ commit }, newItem) {
    commit('RESET_GS_GROUP', newItem)
  },
  addItemToGsGroup({ commit }, newItem) {
    commit('UPDATE_GS_GROUP', newItem)
  },
}

export default actions
